import React, { useEffect, useRef, useState } from 'react';
import Card from '../base/Card';
import './Features.css';

// SVG Icon Components matching within-your-flow style
const BellOffIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    <path d="M18.63 13A17.89 17.89 0 0 1 18 8" />
    <path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14" />
    <path d="M18 8a6 6 0 0 0-9.33-5" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ZapIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const UsersIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BarChartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);

const features = [
  {
    Icon: BellOffIcon,
    title: 'Notification blocker',
    description: 'Block all social media and distracting sites in one click on your laptop so you can stay focused instead of doom‑scrolling.'
  },
  {
    Icon: ZapIcon,
    title: 'Micro resets',
    description: 'Guided 1–3 minute stretches and breathing breaks that reduce tension and clear your head between sessions.'
  },
  {
    Icon: UsersIcon,
    title: 'Community',
    description: 'See when friends are focusing and join shared focus sessions so you don\'t study alone.'
  },
  {
    Icon: BarChartIcon,
    title: 'Analytics',
    description: 'Track focused hours and micro-resets each week so you can see your progress instead of guessing.'
  }
];

function Features() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <section className="features" id="features">
      <div className="features-container">
        {/* Section Header */}
        <div className="features-header">
          <h2 className="features-title title-1">Core features</h2>
          <p className="features-subtitle body-text-secondary">
            Everything you need to get back control and work sustainably.
          </p>
        </div>

        {/* Feature Cards */}
        <div 
          ref={ref}
          className={`features-grid ${isVisible ? 'features-visible' : ''}`}
        >
          {features.map((feature, index) => {
            const Icon = feature.Icon;
            
            return (
              <Card 
                key={index} 
                hoverable={true}
                className="feature-card"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="feature-icon-wrapper">
                  <Icon />
                </div>
                
                {/* Title */}
                <h3 className="feature-title title-3">{feature.title}</h3>
                
                {/* Description */}
                <p className="feature-description body-text-secondary">
                  {feature.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Features;






